const { default: client } = require("../libs/HttpClient");

class TaskEstimationService{
    static async addEstimationHours(request) {
        return client.post('/projects/estimation/store', request);
    }
    static async getEstimationHours(params) {
        return client.get(`/projects/estimation/list`, { params });
    }
    static async updateEstimationHoursStatus(params) {
        return client.put(`/projects/estimation/update-status`, params);
    }
}
export { TaskEstimationService };
